/**
 * Maxime's credentials list — order matters (most relevant first).
 */
export const credentials = [
  { title: 'GZ-psycholoog', where: 'RINO Amsterdam' },
  { title: 'EMDR — complex en vroegkinderlijk trauma', where: 'RINO Amsterdam' },
  {
    title: 'EMDR (Eye Movement Desensitization and Reprocessing)',
    where: 'King Nascholing Amsterdam',
  },
  { title: 'Acceptance and Commitment Therapy', where: 'BOPAdvies' },
  { title: 'Cognitieve Gedragstherapie', where: 'King Nascholing Amsterdam' },
  { title: 'Mindfulness Based Cognitive Therapy', where: 'Centrum voor Mindfulness' },
  { title: 'Master Klinische Psychologie', where: 'Vrije Universiteit Amsterdam' },
];
